/**
 * @file Shared offboarding-status constants.
 *
 * Single source of truth for which per-device decisions count as
 * "settled" — i.e. the admin has made a terminal call (returned, bought,
 * dropped to storage, sent to loot, kept for testing, cancelled). The
 * list is mirrored verbatim in functions/lib/offboarding-statuses.js so
 * Cloud Functions can apply the same rule (currently used by the Bamboo
 * sync to keep an employee in the `offboarding` phase past their last
 * day if devices are still pending — see sync-bamboo.js).
 *
 * Don't drift the two copies. If you add a new terminal status to
 * OFFBOARDING_STATUS in src/config.js, add it here too.
 */

export const SETTLED_DECISION_STATUSES = Object.freeze([
  'returned',
  'bought',
  'in_storage',
  'to_loot',
  'to_testing',
  'cancelled',
]);

export function isSettledDecision(status) {
  return SETTLED_DECISION_STATUSES.includes(status);
}

// Device-branch statuses that should write a /handovers audit row when
// reached. DISTINCT from SETTLED above: 'cancelled' is settled but logs no
// handover, and these are the physical-device terminals only. Used by the
// offboarding workflow row handler.
export const DEVICE_HANDOVER_TRIGGER_STATUSES = Object.freeze([
  'returned',
  'bought',
  'in_storage',
  'to_loot',
  'to_testing',
]);

// Phone-tariff branch terminals (Bamboo-asset workflow). Separate state
// machine from the device branch; reaching one logs a handover row too.
export const PHONE_TARIFF_TERMINAL_STATUSES = Object.freeze([
  'transferred',
  'disconnected',
]);
